// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"066932ee","828":"a5b39049","1237":"7c080214","3188":"0fc10f32","4151":"9baa25da","5862":"5c25bfa1","7085":"96aee2f2","7532":"84deb361","8303":"6081c46c","8647":"31d6cfe0"}[chunkId] + ".chunk.css";
};